import { render, staticRenderFns } from "./WatDocuments.vue?vue&type=template&id=4f8829d6&"
import script from "./WatDocuments.vue?vue&type=script&lang=js&"
export * from "./WatDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports